export default {
    isDisplayOnly: (productInfo) => productInfo?.StockStatus === 'DisplayOnly',
};
